module.exports = __webpack_public_path__ + "public/SiteIcons/heartFil.png?064d719e";